import {
  Breadcrumbs,
  Card,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { EmployeeCutOffNotification } from '@omnipresentgroup/features';
import { FormProvider } from '@omnipresentgroup/flexible-forms';
import { EMPLOYEE_ID_PARAM } from '@omnipresentgroup/shared';
import { useNavigate, useSearchParams } from 'react-router';

import { EmployeeSelector } from '../../../components';
import { ADDITIONAL_PAY_PATH } from '../../../constants';
import { AddVariantPaymentForm } from '../../../features/variant-payments';

const PAGE_TITLE = 'Add additional pay';

export const AddAdditionalPay = () => {
  const navigate = useNavigate();

  const [searchParameters] = useSearchParams();

  const employeeId = new URLSearchParams(searchParameters).get(
    EMPLOYEE_ID_PARAM,
  ) as string;

  const PageHeader = () => {
    return (
      <Inline justify="space-between" minH={40} align="center">
        <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
          {PAGE_TITLE}
        </Typography>
      </Inline>
    );
  };

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate('/') },
            {
              id: 'additional-pay',
              title: 'Additional pay',
              onClick: () =>
                navigate(
                  `${ADDITIONAL_PAY_PATH}${
                    employeeId ? `?${EMPLOYEE_ID_PARAM}=${employeeId}` : ''
                  }`,
                ),
            },
            {
              id: 'add-additional-pay',
              title: 'Add',
              active: true,
            },
          ]}
        />
        <PageHeader />
      </Stack>
      <Inline justify="center">
        <Card p="32" maxW={600} w="stretch">
          <Stack>
            {employeeId && (
              <EmployeeCutOffNotification employeeId={employeeId} />
            )}
            <EmployeeSelector label="Employee *" showOnlyActive />
            {employeeId && (
              <FormProvider>
                <AddVariantPaymentForm employeeId={employeeId} />
              </FormProvider>
            )}
          </Stack>
        </Card>
      </Inline>
    </>
  );
};
